export var FetchActions;
(function (FetchActions) {
    /**
     * Action representing a fetch operation.
     */
    FetchActions["FETCH"] = "fetch";
    /**
     * Action representing a successful resolution of the fetch operation.
     */
    FetchActions["RESOLVE"] = "resolve";
    /**
     * Action representing a rejection or failure of the fetch operation.
     */
    FetchActions["REJECT"] = "reject";
    /**
     * Action representing an abort of a fetch
     */
    FetchActions["ABORT"] = "abort";
})(FetchActions || (FetchActions = {}));
//# sourceMappingURL=FetchActions.js.map